import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="bg-background-50 rounded-2xl px-8 md:px-12 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div>
              <Link
                to="/"
                className="text-lg font-semibold text-foreground-900 tracking-tight whitespace-nowrap hover:text-primary-600 transition-colors"
              >
                CSSSpreadsheet<span className="text-primary-500">.</span>lifestyle
              </Link>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                Your trusted hub for CSSBuy spreadsheet directories, shopping agent comparisons, and curated fashion item lists. Helping Western buyers save up to 60% on sourcing from China agents since 2026.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">
                Spreadsheets
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    CSSBuy Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    Kakobuy Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    Superbuy Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    OOPBuy Spreadsheet
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">
                Categories
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    Shoes
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    Hoodies &amp; Sweaters
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    T-Shirts
                  </a>
                </li>
                <li>
                  <Link to="/what-is-cssbuy-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    SEO Guide
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">
                Resources
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/what-is-cssbuy-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    What is CSSBuy Spreadsheet?
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    Buy It Now
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    CSSBuy Sheet
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 CSSSpreadsheet.lifestyle. All rights reserved. This site contains affiliate links.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}